export const convertStringToBaseTenNumber = (value: string): number =>
  parseInt(value, 10);
